
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { useForm } from "../../../../hooks/useForm";
import { Grid, Button } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { seleccionarDetalleFacturacionSinCotizacion } from "../../../../actions/compras/AuditoriaFactura";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import BuscadorMateriales from "../../../autorizaciones/UI/BuscadorMateriales";
import { useRef, useState } from "react";

export const FormDetalleConCotizacion = (props) => {
    const { materiales } = props
    const dispatch = useDispatch();
    console.log(props.materiales)
    const [codigoMaterial, setCodigoMaterial] = useState(null);
    const codigoMaterialRef = useRef(null);

    const formInicial = {
        producto: "",
        cantidad: "",
        precioUnitario: "",
        idMaterial: ""
    }

    const [formValues, handleInputChange] = useForm(materiales ? materiales : formInicial);

    const handleSave = (e) => {
        

        e.preventDefault();
        formValues.producto = materiales ? materiales.producto : codigoMaterial.descripcion;
        formValues.idMaterial = materiales ? materiales.idMaterial : codigoMaterial.codigoNum;
        if(materiales !== null){
            props.handleEdit(formValues);
        }else{
            dispatch(seleccionarDetalleFacturacionSinCotizacion(formValues));
        }
    }
    return (
        <ValidatorForm onSubmit={handleSave}>
            <Grid container style={{ padding: 25 }}>
                {materiales === null && (
                    <Grid item xs={12} md={12}>
                        <BuscadorMateriales
                            ref={codigoMaterialRef}
                            cod={codigoMaterial}
                            label="Código Material"
                            setCod={(val) => setCodigoMaterial(val)}
                        />
                    </Grid>
                )}
                <Grid item xs={12} md={6} style={{ marginTop: '1rem', marginRight: '0.5rem' }}>
                    <TextValidator
                        margin="normal"
                        name="material"
                        value={materiales ? materiales.producto : codigoMaterial?.descripcion !== undefined ? codigoMaterial.descripcion : ""}
                        autoComplete="off"
                        fullWidth
                        style={{ paddingRight: "0.5rem" }}
                        validators={["required"]}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextValidator
                        margin="normal"
                        label="Cantidad"
                        name="cantidad"
                        value={formValues.cantidad}
                        autoComplete="off"
                        onChange={handleInputChange}
                        fullWidth
                        style={{ paddingRight: "0.5rem" }}
                        validators={["required", "isNumber"]}
                        errorMessages={["La cantidad es requerida."]}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextValidator
                        margin="normal"
                        label="Precio Unitario"
                        name="precioUnitario"
                        value={formValues.precioUnitario}
                        autoComplete="off"
                        onChange={handleInputChange}
                        fullWidth
                        style={{ paddingRight: "0.5rem" }}
                        validators={["required", "isNumber"]}
                        errorMessages={["El precio es requerido."]}
                    />
                </Grid>
                <Grid container style={{ padding: 25 }} >
                    <Grid item xs={12}>
                        <Grid
                            container
                            spacing={1}
                            direction="row"
                            justify="flex-end"
                            alignItems="center"
                        >
                            <Button
                                variant="contained"
                                color="secondary"
                                size="small"
                                startIcon={<CancelIcon />}
                                onClick={props.cerrarModal}
                            >
                                CANCELAR
                            </Button>
                            {
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    startIcon={<SaveIcon />}
                                    type='submit'
                                    style={{ marginLeft: "0.5rem" }}
                                    onClick={props.cerrarModal}
                                >
                                    AGREGAR
                                </Button>
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </ValidatorForm >
    )
};
